<template>
  <el-dropdown trigger="click" @command="commandHandler">
    <span class="el-dropdown-link"><slot></slot></span>
    <el-dropdown-menu slot="dropdown" class="tab-shell-selector-menu">
      <el-dropdown-item v-for="item in shellList" :key="item.id" :command="item">
        <div class="shell-item">
          <div class="shell-item-left">{{item}}</div>
          <div class="shell-item-right">{{utils.hotKey.getTextByName(`newSess${item}`)}}</div>
        </div>
      </el-dropdown-item>

      <divider />

      <el-dropdown-item command="sessions">
        <div class="shell-item">
          <div class="shell-item-left">Sessions...</div>
          <div class="shell-item-right">{{utils.hotKey.getTextByName("showSessions")}}</div>
        </div>
      </el-dropdown-item>

      <el-dropdown-item command="settings">
        <div class="shell-item">
          <div class="shell-item-left">Settings</div>
          <div class="shell-item-right">{{utils.hotKey.getTextByName("settings")}}</div>
        </div>
      </el-dropdown-item>

    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Divider from '../common/divider.vue'

export default {
  name: "tabShellSelector",
  components: { Divider },
  data() {
    return {
     shellList: [],
     hotKeyGroup: new this.utils.hotKey.HotKeyGroup("shell", "终端", [], true, false)
    }
  },
  mounted() {
    this.updateShellList()
  },
  methods: {
    updateShellList() {
      let self = this
      this.api.shell.getShellList((error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        // console.log('updateShellList API called successfully. Returned data: ', data)
        self.shellList = data
        self.bindHotKeys()
      });
    },
    commandHandler(command) {
      switch (command) {
        case 'sessions':
          this.env.showSessionList()
          break
        case 'settings':
          this.env.ui.showOptions()
          break
        default:
          this.newSess(command)
      }
    },
    newSess(name) {
      this.$emit('command', name)
    },
    newSessByHotKey(combo) {
      let keys = combo.split("+")
      let num = parseInt(keys[keys.length - 1])
      let shell = this.shellList[num]
      this.newSess(shell)
    },
    bindHotKeys() {
      let self = this
      for (let i in self.shellList) {
        if (i > 9) break

        let s = self.shellList[i]
        let hk = new self.utils.hotKey.HotKey(
            `newSess${s}`,
            [`ctrl+alt+${i}`],
            self.newSessByHotKey,
            `${s}`,
        )
        self.hotKeyGroup.addKey(hk)
        hk.bind()
      }
      self.utils.hotKey.GlobalHotKey.addGroup(self.hotKeyGroup)
    }
  },
}
</script>

<style scoped>
.tab-shell-selector-menu {
  user-select: none;
}
.shell-item {
  display: flex;
  justify-content: space-between;
}
.shell-item-left {
  /* text-transform: capitalize; */
}
.shell-item-right {
  font-size: 0.8em;
  color: #777;
  margin-left: 2em;
}
</style>

<style>
.el-dropdown-menu {
  background: #333333;
  border: none;
}
.el-dropdown-menu__item {
  color: #bbb;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  color: #fff;
  background-color: #3c3c3c;
}
.el-popper[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: #333333;
}
.el-popper[x-placement^=bottom] .popper__arrow {
  border-bottom-color: #333333;
}
</style>
